import { PropsWithChildren, ReactNode, useState } from 'react'
import { mdiTrashCanOutline } from '@mdi/js'

import { CommonLinkButton } from 'components/Button'
import { SpinnerCentered } from 'components/Loader'
import DeleteHomeConfigModal from './ConfirmDeleteModal'
import { DeleteIcon } from './styles'

interface DeleteHomeConfigCellProps {
  handleConfirm: () => void
  title: ReactNode
  disabled?: boolean
}

export function DeleteHomeConfigCell({
  children,
  handleConfirm,
  title,
  disabled,
}: PropsWithChildren<DeleteHomeConfigCellProps>) {
  const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] =
    useState(false)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <>
      {isLoading && <SpinnerCentered size="24" />}
      {isConfirmDeleteModalOpen && (
        <DeleteHomeConfigModal
          isOpen
          handleDiscard={() => setIsConfirmDeleteModalOpen(false)}
          handleConfirm={async () => {
            setIsConfirmDeleteModalOpen(false)
            setIsLoading(true)
            await handleConfirm()
            setIsLoading(false)
          }}
          title={title}
        >
          {children}
        </DeleteHomeConfigModal>
      )}
      {!isLoading && (
        <CommonLinkButton
          onClick={() => setIsConfirmDeleteModalOpen(true)}
          disabled={disabled}
        >
          <DeleteIcon path={mdiTrashCanOutline} size={1} disabled={disabled} />
        </CommonLinkButton>
      )}
    </>
  )
}
